/* eslint-disable import/no-webpack-loader-syntax */ import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import hexagonOrangeUrl from '../../../assets/gems/hexagon_orange.svg?inline';
export function HexagonOrange({ ...props }) {
    return /*#__PURE__*/ _jsx("img", {
        ...props,
        src: hexagonOrangeUrl,
        alt: "HexagonOrangeImage"
    });
}
